export default "__VITE_ASSET__CsxiWqkn__"